import { Host, h } from '@stencil/core';
export class AibaLegend {
  constructor() {
    this.styles = undefined;
    this.text = undefined;
    this.variant = 'low';
    this.customVariant = undefined;
    this.data = undefined;
    this.renderWithoutData = false;
  }
  render() {
    var _a;
    if (typeof this.data === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    if (this.renderWithoutData) {
      return (h("div", { class: `legend_wrapper ${this.customVariant}` }, h("span", { class: `static-legend` }, " "), h("aiba-label", { tag: "span", "aria-label": this.text, text: this.text ? this.text : '' })));
    }
    if (!this.renderWithoutData) {
      return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: "legend-wrapper" }, this.data &&
        ((_a = this.data.elements) === null || _a === void 0 ? void 0 : _a.map((element) => {
          if (element && element['name'] === 'div' && element['tag'] === 'color')
            return h("div", { class: `color-div ${this.variant ? this.variant : ''}` });
          if (element && element['name'] === 'aiba-label' && element['tag'] === 'text')
            return (h("aiba-label", Object.assign({ "aria-label": element === null || element === void 0 ? void 0 : element.data['text'], key: element === null || element === void 0 ? void 0 : element.data['text'] }, element === null || element === void 0 ? void 0 : element.data, { text: this.text ? this.text : element === null || element === void 0 ? void 0 : element.data['text'] })));
        })))));
    }
  }
  static get is() { return "aiba-legend"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-legend.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-legend.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "text",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'low' | 'medium' | 'high' | 'dashed'",
          "resolved": "\"dashed\" | \"high\" | \"low\" | \"medium\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "'low'"
      },
      "customVariant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "custom-variant",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "renderWithoutData": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "render-without-data",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
}
//# sourceMappingURL=aiba-legend.js.map
